import React, { useContext } from "react";
import "./Results.css";

import clsx from 'clsx';
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Collapse from "@material-ui/core/Collapse";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
//import CardCollapse from "../../../components/CardCollapse/CardCollapse";
import CardCollapseMini from "../../../components/CardCollapseMini/CardCollapseMini";
import DialogFullScreen from "../../../components/DialogFullScreen/DialogFullScreen";
import Highlight from "../../../components/Highlight/Highlight";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import { withRouter } from "react-router";

import CrclContext from "../contexts/CrclContext";
import { IconButton } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  card: {
    marginTop: 20,
    marginBottom: 20,
  },
  estimatesHeading: {
    display: 'flex'
  },
  expand: {
    padding: 0,
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  title: {
    fontSize: 14,
  },
  references: {
    backgroundColor: "#EAFAFD",
    padding: 20,
  },
  highlight: {
    paddingLeft: 0,
  },
  highlightIcon: {
    minWidth: 40,
  },
  divider: {
    marginTop: 20,
    marginBottom: 20,
  },
  dividerFormula: {
    marginTop: 2,
    marginBottom: 2,
    backgroundColor: "#000000",
    width: "250px",
  },
  heading: {
    marginBottom: 20,
  },
  image: {
    padding: 20,
  },
  topButtom: {
    color: "default",
    width: "100%",
  },
}));

const Results = (props) => {
  const crclcontext = useContext(CrclContext);
  const classes = useStyles();

  const backToCalc = (e) => {
    e.preventDefault();
    props.history.push("/calculator");
  };
  
  const [estExpanded, setEstExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setEstExpanded(!estExpanded);
  };

  let cockcroft = [
    <div id="top" />,
    <Typography variant="body2">
      <p>
        The Cockcroft-Gault equation estimates CrCl in mL/minute and has 
        been successfully used in the calculation of drug doses in adults 
        with renal impairment.
      </p>
    </Typography>,
    <Typography variant="body1">
      <strong>ADULT MALES</strong>
    </Typography>,
    <Typography variant="body2">
      [140 - age] x ideal body weight (kg)
    </Typography>,
    <Divider className={classes.dividerFormula} />,
    <Typography variant="body2">
      0.814 x serum creatinine (micromol/L)
    </Typography>,
    <Typography variant="body1" style={{ marginTop: 20 }}>
      <strong>ADULT FEMALES</strong>
    </Typography>,
    <Typography variant="body2">Multiply above equation by 0.85</Typography>,
    <Typography variant="body2">
      <p>
      For more detailed information on how to adjust drug doses in chronic
      kidney disease see:
      <a target="_blank" href="https://www.nps.org.au/australian-prescriber/articles/how-to-adjust-drug-doses-in-chronic-kidney-disease">https://www.nps.org.au/australian-prescriber/articles/how-to-adjust-drug-doses-in-chronic-kidney-disease</a>
      </p>
    </Typography>,
  ];

  let dosingGuidelines = [
    <Typography variant="h6">Full anticoagulation</Typography>,
    <CardCollapseMini
      title="CrCl less than 30 mL/min"
      content={[
        <Typography variant="h6" color="primary">
          Use IV Heparin
        </Typography>,
        <Typography variant="body2"><p>as patient has severe renal impairment.</p></Typography>,
        <Typography variant="body1" style={{ marginTop: 20 }}>
          <strong>IV HEPARIN</strong>
        </Typography>,
        <Typography variant="body2">
          <p>
            IV Heparin treatment dose and monitoring is to occur in accordance
            with
          </p>
          <p>
            <strong>
              <a target="_blank" href="https://qheps.health.qld.gov.au/__data/assets/pdf_file/0040/1797961/sw014-heparin-form.pdf">Adult Heparin intravenous infusion order and administration form</a>
            </strong>
          </p>
        </Typography>,
        <Typography variant="body1" style={{ marginTop: 20 }}>
          <strong>ENOXAPARIN</strong>
        </Typography>,
        <Typography variant="body2">
          <p>Enoxaparin treatment dose based upon consultant advice.</p>
          <p>The usual recommended dose in this patient population is 1mg/kg ONCE daily.</p>
          <p>
            If enoxaparin is selected, discuss with consultant prior to
            prescribing.
          </p>
          <p>
            <strong>
              Documented consultant approval is required for therapeutic
              enoxaparin use in patients if CrCl less than 30mL/min.
            </strong>
          </p>
        </Typography>,
        <Typography variant="body1" style={{ marginTop: 20 }}>
          <strong>ENOXAPARIN MONITORING</strong>
        </Typography>,
        <Typography variant="body2">
          <p>
            If enoxaparin is used, and treatment is to be continued beyond 48
            hours:
          </p>
          <p>
            Measure TROUGH anti-factor Xa level (23hours post dose) after
            3rd dose and then measure every second day.
          </p>
        </Typography>,
      ]}
    />,
    <CardCollapseMini
      title="CrCl between 30 and 50 mL/min"
      content={[
        <CardCollapseMini 
          title="Patients less than 120kg"
          content={[
            <Typography variant="h6" color="primary">
              Use Enoxaparin or IV Heparin
            </Typography>,
            <Typography gutterBottom variant="body1" style={{ marginTop: 20 }}>
              <strong>
                ENOXAPARIN <br /> TREATMENT DOSE IS
              </strong>
            </Typography>,
            <Typography variant="h6" color="primary">
              1mg/kg TWICE DAILY
            </Typography>,
            <Typography variant="body2">
              <p>Round weight to nearest 10kg when dosing and round down if interval of 5kg</p>
            </Typography>,
            <Typography variant="body1" style={{ marginTop: 20 }}>
              <strong>ENOXAPARIN MONITORING</strong>
            </Typography>,
            <Typography variant="body2">
              <p>If treatment is to be continued beyond 48 hours:</p>
              <p>
                Measure PEAK anti-factor Xa level (4hours post dose) after 3rd or 4th
                dose (to coincide with laboratory hours) and then measure every
                second day.
              </p>
              <p>
                Strongly consider IV heparin in extremes of body size, severe liver
                disease, diseases of skeletal muscle and elderly patients with low
                body weight (as CrCl may be inaccurate).
              </p>
              <p>
                Use IV heparin if anti-factor Xa measurements are unavailable or
                renal function is unstable (e.g. acute kidney failure).
              </p>
            </Typography>,
            <Typography variant="body1" style={{ marginTop: 20 }}>
              <strong>IV HEPARIN</strong>
            </Typography>,
            <Typography variant="body2">
              <p>
                IV Heparin treatment dose and monitoring is to occur in accordance
                with
              </p>
              <p>
                <strong>
                  <a target="_blank" href="https://qheps.health.qld.gov.au/__data/assets/pdf_file/0040/1797961/sw014-heparin-form.pdf">Adult Heparin intravenous infusion order and administration form</a>
                </strong>
              </p>
            </Typography>,
          ]}
        />,
        <CardCollapseMini
      title="Patients greater than 120kg or BMI greater than 40kg/m2"
      content={[
        <Typography variant="h6" color="primary">
          IV Heparin is preferred agent
        </Typography>,
        <Typography variant="body2">
          <p>
            because patient is overweight or obese
            CrCl estimates may also be inaccurate and evidence 
            for use of enoxaparin is limited at extremes of body weight.
          </p>
        </Typography>,
        <Typography variant="body1" style={{ marginTop: 20 }}>
          <strong>IV HEPARIN</strong>
        </Typography>,
        <Typography variant="body2">
          <p>
            IV Heparin treatment dose and monitoring is to occur in accordance
            with
          </p>
          <p>
            <strong>
              <a target="_blank" href="https://qheps.health.qld.gov.au/__data/assets/pdf_file/0040/1797961/sw014-heparin-form.pdf">Adult Heparin intravenous infusion order and administration form</a>
            </strong>
          </p>
          <p>
            If IV access is not possible, discuss use of enoxaparin with
            consultant prior to prescribing.
          </p>
        </Typography>,
        <Typography variant="body1" style={{ marginTop: 20 }}>
          <strong>ENOXAPARIN</strong>
        </Typography>,
        <Typography variant="body2">
          <p>Enoxaparin treatment dose based upon consultant advice.</p>
          <p>
            If enoxaparin is selected, discuss with consultant prior to
            prescribing.
          </p>
          <p>
            Note: Enoxaparin dose-capping may limit supratherapeutic levels but
            may result in under-dosing. Weight based enoxaparin dosing using
            actual body weight may result in over-dose and bleeding. Ensure
            monitoring if enoxaparin is used.
          </p>
        </Typography>,
        <Typography variant="body1" style={{ marginTop: 20 }}>
          <strong>ENOXAPARIN MONITORING</strong>
        </Typography>,
        <Typography variant="body2">
          <p>If treatment is to be continued beyond 48 hours:</p>
          <p>
            Measure PEAK anti-factor Xa level (4hours post dose) after 3rd or 4th
            dose (to coincide with laboratory hours) and then measure every
            second day.
          </p>
        </Typography>,
      ]}
    />,
      ]}
    />,
    <CardCollapseMini
      title="CrCl greater than 50 mL/min"
      content={[
        <CardCollapseMini 
          title="Patients between 50kg and 100kg"
          content={[
            <Typography variant="h6" color="primary">
              Use Enoxaparin or IV Heparin
            </Typography>,
            <Typography gutterBottom variant="body1" style={{ marginTop: 20 }}>
              <strong>
                ENOXAPARIN <br /> TREATMENT DOSE IS
              </strong>
            </Typography>,
            <Typography variant="h6" color="primary">
              1mg/kg TWICE DAILY
            </Typography>,
            <Typography variant="body2">
              <p>Round weight to nearest 10kg when dosing and round down if interval of 5kg</p>
            </Typography>,
            <Typography variant="body1" style={{ marginTop: 20 }}>
              <strong>ENOXAPARIN MONITORING</strong>
            </Typography>,
            <Typography variant="body2">
              <p>If treatment is to be continued beyond 5 days: </p>
              <p>
                Measure PEAK anti-factor Xa level (4hours post dose) after 5 days
                (to coincide with laboratory hours) and then measure every
                second day.
              </p>
              <p>
                Strongly consider IV heparin in extremes of body size, severe liver
                disease, diseases of skeletal muscle and elderly patients with low
                body weight (as CrCl may be inaccurate).
              </p>
              <p>
                Use IV heparin if anti-factor Xa measurements are unavailable or
                renal function is unstable (e.g. acute kidney failure).
              </p>
            </Typography>,
            <Typography variant="body1" style={{ marginTop: 20 }}>
              <strong>IV HEPARIN</strong>
            </Typography>,
            <Typography variant="body2">
              <p>
                IV Heparin treatment dose and monitoring is to occur in accordance
                with
              </p>
              <p>
                <strong>
                  <a target="_blank" href="https://qheps.health.qld.gov.au/__data/assets/pdf_file/0040/1797961/sw014-heparin-form.pdf">Adult Heparin intravenous infusion order and administration form</a>
                </strong>
              </p>
            </Typography>,
          ]}
        />,
        <CardCollapseMini 
          title="Patients less than 50kg or between and 100kg and 120kg"
          content={[
            <Typography variant="h6" color="primary">
              Use Enoxaparin or IV Heparin
            </Typography>,
            <Typography gutterBottom variant="body1" style={{ marginTop: 20 }}>
              <strong>
                ENOXAPARIN <br /> TREATMENT DOSE IS
              </strong>
            </Typography>,
            <Typography variant="h6" color="primary">
              1mg/kg TWICE DAILY
            </Typography>,
            <Typography variant="body2">
              <p>Round weight to nearest 10kg when dosing and round down if interval of 5kg</p>
            </Typography>,
            <Typography variant="body1" style={{ marginTop: 20 }}>
              <strong>ENOXAPARIN MONITORING</strong>
            </Typography>,
            <Typography variant="body2">
              <p>If treatment is to be continued beyond 48 hours: </p>
              <p>
                Measure PEAK anti-factor Xa level (4hours post dose) after 3rd or 4th
                dose (to coincide with laboratory hours) and then measure every
                second day.
              </p>
              <p>
                Strongly consider IV heparin in extremes of body size, severe liver
                disease, diseases of skeletal muscle and elderly patients with low
                body weight (as CrCl may be inaccurate).
              </p>
              <p>
                Use IV heparin if anti-factor Xa measurements are unavailable or
                renal function is unstable (e.g. acute kidney failure).
              </p>
            </Typography>,
            <Typography variant="body1" style={{ marginTop: 20 }}>
              <strong>IV HEPARIN</strong>
            </Typography>,
            <Typography variant="body2">
              <p>
                IV Heparin treatment dose and monitoring is to occur in accordance
                with
              </p>
              <p>
                <strong>
                  <a target="_blank" href="https://qheps.health.qld.gov.au/__data/assets/pdf_file/0040/1797961/sw014-heparin-form.pdf">Adult Heparin intravenous infusion order and administration form</a>
                </strong>
              </p>
            </Typography>,
          ]}
        />,
        <CardCollapseMini
      title="Patients greater than 120kg or BMI greater than 40kg/m2"
      content={[
        <Typography variant="h6" color="primary">
          IV Heparin is preferred agent
        </Typography>,
        <Typography variant="body2">
          <p>
            because patient is underweight, overweight or obese
            CrCl estimates may also be inaccurate and evidence 
            for use of enoxaparin is limited at extremes of body weight.
          </p>
        </Typography>,
        <Typography variant="body1" style={{ marginTop: 20 }}>
          <strong>IV HEPARIN</strong>
        </Typography>,
        <Typography variant="body2">
          <p>
            IV Heparin treatment dose and monitoring is to occur in accordance
            with
          </p>
          <p>
            <strong>
              <a target="_blank" href="https://qheps.health.qld.gov.au/__data/assets/pdf_file/0040/1797961/sw014-heparin-form.pdf">Adult Heparin intravenous infusion order and administration form</a>
            </strong>
          </p>
          <p>
            If IV access is not possible, discuss use of enoxaparin with
            consultant prior to prescribing.
          </p>
        </Typography>,
        <Typography variant="body1" style={{ marginTop: 20 }}>
          <strong>ENOXAPARIN</strong>
        </Typography>,
        <Typography variant="body2">
          <p>Enoxaparin treatment dose based upon consultant advice.</p>
          <p>
            If enoxaparin is selected, discuss with consultant prior to
            prescribing. Documented consultant approval is required for 
            therapeutic enoxaparin use if patient weight is more than 120kg.
          </p>
          <p>
            Note: Enoxaparin dose-capping may limit supratherapeutic levels but
            may result in under-dosing. Weight based enoxaparin dosing using
            actual body weight may result in over-dose and bleeding. Ensure
            monitoring if enoxaparin is used.
          </p>
        </Typography>,
        <Typography variant="body1" style={{ marginTop: 20 }}>
          <strong>ENOXAPARIN MONITORING</strong>
        </Typography>,
        <Typography variant="body2">
          <p>If treatment is to be continued beyond 48 hours:</p>
          <p>
            Measure PEAK anti-factor Xa level (4hours post dose) after 3rd or 4th
            dose (to coincide with laboratory hours) and then measure every
            second day.
          </p>
        </Typography>,
      ]}
    />,
      ]}
    />,
    <Typography variant="h6">Prophylaxis</Typography>,
    <CardCollapseMini
      title="CrCl less than 30 mL/min"
      content={[
        <Typography variant="body1">
          <strong>
            ENOXAPARIN <br />
            PROPHYLATIC DOSE{" "}
          </strong>
        </Typography>,
        <Typography variant="h5" color="primary">
          20mg ONCE DAILY
        </Typography>,
        <Typography variant="body1" style={{ marginTop: 20 }}>
          <p>Use chemoprophylaxis according to VTE risk.</p>
        </Typography>,
        <Typography variant="body1" style={{ marginTop: 20 }}>
          <p><a target="_blank" href="https://qheps.health.qld.gov.au/__data/assets/pdf_file/0035/2397554/002897.pdf">Refer to VTE guidelines.</a></p>
        </Typography>,
        <Typography variant="body1" style={{ marginTop: 20 }}>
          <strong>ENOXAPARIN MONITORING</strong>
        </Typography>,
        <Typography variant="body2">
          <p>
            Routine monitoring of anti-factor Xa is not recommended for patients
            on enoxaparin prophylaxis.{" "}
          </p>
          <p>
            If any significant bleeding occurs, enoxaparin should be stopped and
            urgent consultant review organised. Anti-factor Xa measurement may
            assist with management.
          </p>
        </Typography>,
      ]}
    />,
    <CardCollapseMini
      title="CrCl greater than 30 mL/min"
      content={[
        <CardCollapseMini
          title="Patients less than 50kg"
          content={[
            <Typography variant="body1">
              <strong>
                ENOXAPARIN <br />
                PROPHYLATIC DOSE{" "}
              </strong>
            </Typography>,
            <Typography variant="h5" color="primary">
              20mg ONCE DAILY
            </Typography>,
            <Typography variant="body1" style={{ marginTop: 20 }}>
              <p>Use chemoprophylaxis according to VTE risk.</p>
            </Typography>,
            <Typography variant="body1" style={{ marginTop: 20 }}>
              <p><a target="_blank" href="https://qheps.health.qld.gov.au/__data/assets/pdf_file/0035/2397554/002897.pdf">Refer to VTE guidelines.</a></p>
            </Typography>,
            <Typography variant="body1" style={{ marginTop: 20 }}>
              <strong>ENOXAPARIN MONITORING</strong>
            </Typography>,
            <Typography variant="body2">
              <p>
                Routine monitoring of anti-factor Xa is not recommended for patients
                on enoxaparin prophylaxis.{" "}
              </p>
              <p>
                If any significant bleeding occurs, enoxaparin should be stopped and
                urgent consultant review organised. Anti-factor Xa measurement may
                assist with management.
              </p>
            </Typography>,
          ]}
        />,
      <CardCollapseMini
          title="Patients greater than 50kg"
          content={[
        <Typography variant="body1">
          <strong>
            ENOXAPARIN <br />
            PROPHYLATIC DOSE{" "}
          </strong>
        </Typography>,
        <Typography variant="h5" color="primary">
          40mg ONCE DAILY
        </Typography>,
        <Typography variant="body1" style={{ marginTop: 20 }}>
          <p>Use chemoprophylaxis according to VTE risk.</p>
        </Typography>,
        <Typography variant="body1" style={{ marginTop: 20 }}>
          <p><a target="_blank" href="https://qheps.health.qld.gov.au/__data/assets/pdf_file/0035/2397554/002897.pdf">Refer to VTE guidelines.</a></p>
        </Typography>,
        <Typography variant="body1" style={{ marginTop: 20 }}>
          <strong>ENOXAPARIN MONITORING</strong>
        </Typography>,
        <Typography variant="body2">
          <p>
            Routine monitoring of anti-factor Xa is not recommended for patients
            on enoxaparin prophylaxis.{" "}
          </p>
          <p>
            If any significant bleeding occurs, enoxaparin should be stopped and
            urgent consultant review organised. Anti-factor Xa measurement may
            assist with management.
          </p>
        </Typography>,
        ]}
      />
      ]}
    />,
    <CardCollapseMini
          title="Patients greater than 120kg OR BMI greater than 40kg/m2"
          content={[
        <Typography variant="body1" style={{ marginTop: 20 }}>
          <p>Seek consultant advice for appropriate dose in this population.</p>
        </Typography>,
        ]}
      />
  ];

  let doseAdjustments = [
    <Typography variant="h6" className={classes.heading}>
      Dose adjustment
    </Typography>,
    <Typography>
      {crclcontext.renalImpairmentLevel == 'severe' ? 
      [<Typography variant="body2">Advice on dose adjustment can be sought by discussion with consultant, haematologist or clinical pharmacist.</Typography>] 
      : [
        <Typography variant="body2">
      The following equation can be used to assist with enoxaparin dose adjustments.  Consider indication, renal function and patient weight when determining dose adjustments.{" "}
    </Typography>,
    <img
      alt="Dosing formula"
      src={require("../Results/formula.svg").default}
      className={classes.image}
    />,
    <Typography variant="body2">
      <p>
        Aim for FOUR hours post dose (peak) level of between 0.5 and 1 anti-factor Xa
        units/mL for twice daily dosing. Usual target level is 0.75 anti-factor Xa units/mL.
      </p>
    </Typography>,
    <Typography variant="body2">
      Further advice on dose adjustment can be sought by discussion with consultant, haematologist or clinical pharmacist.
    </Typography>,
      ]}
    </Typography>,
    
  ];
// console.log('crclcontext', crclcontext); //DG Testing
// console.log('crclcontext.renalImpairmentLevel', JSON.stringify(crclcontext.renalImpairmentLevel)); //DG Testing
  let monitoringGuidelines = [
    <Typography variant="h6" display="block">
      How to monitor enoxaparin?
    </Typography>,
    <Typography variant="body2">
      <strong>{crclcontext.renalImpairmentLevel == "severe" ? "Documented consultant approval is required for therapeutic enoxaparin use in patients if CrCl less than 30mL/min" : ""}</strong>
      <p>Use anti-factor Xa assay (reported in Auslab as Clexane assay)</p>
      <p>
        Blood must be taken{" "}
        <strong>
          {crclcontext.renalImpairmentLevel == "severe" ? "TWENTY THREE (23) HOURS post dose (TROUGH)" : "FOUR HOURS post dose (PEAK)"} in{" "}
          <span style={{ color: "#0a2e83" }}>blue top (citrate) tube.</span>
        </strong>
      </p>
      <p>
        Time the blood level to coincide with haematology laboratory hours (e.g.
        1200, rather than 2400 for a patient on enoxaparin at 0800 and 2000).
      </p>
      <p>
        {crclcontext.renalImpairmentLevel == 'severe' ? `Aim for TWENTY THREE (23) HOUR level of LESS THAN 0.5 anti-factor Xa 
        units/mL for once daily dosing in patients with severe renal impairment.` 
        : `Aim for FOUR hours post dose (peak) level of between 0.5 and 1 anti-factor Xa
        units/mL for twice daily dosing. Usual target level is 0.75 anti-factor Xa units/mL.`}
        
      </p>
    </Typography>,
    <Highlight
      type="attention"
      text="The therapeutic range 1 to 2 anti-factor Xa units per mL on the Auslab screen is for ONCE DAILY DOSING with 1.5 mg/kg daily in patients with NORMAL RENAL FUNCTION. This dose is not recommended for inpatients. "
    />,
    <CardCollapseMini
      title="CrCl less than 30 mL/min"
      content={[
        <Typography>
          Severe renal impairment

          <p><strong>Documented consultant approval is required for therapeutic enoxaparin use in patients if CrCl less than 30mL/min.</strong></p>
          <p>
            If enoxaparin is used, and treatment is to be continued beyond 48
            hours, `measure TROUGH anti-factor Xa level (23 hours post dose) after the 
            3rd dose and then measure every second day.
            <br/><br/>
            Advice on monitoring enoxaparin can be sought by discussion with consultant, 
            haematologist or clinical pharmacist.      
          </p>
        </Typography>,
      ]}
    />,
    <CardCollapseMini
      title="CrCl between 30 and 50 mL/min"
      content={[
        <Typography>
          Moderate renal impairment
          <p>
            If enoxaparin is used, and treatment is to be continued beyond 48
            hours, measure anti-factor Xa level (4 hours post dose) after the
            3rd or 4th dose and then measure every second day 
          </p>
        </Typography>,
      ]}
    />,
    <CardCollapseMini
      title="CrCl greater than 50 mL/min"
      content={[
        <Typography>
          If enoxaparin treatment is to be continued beyond 5 days, measure
          anti-factor Xa level (4hours post dose) on day 5 (4 hours post dose 
          to coincide with laboratory hours) and then measure every second day.
        </Typography>,
      ]}
    />,
    <CardCollapseMini
      title="Patients greater than 120kg or BMI greater than 40kg/m2"
      content={[
        <Typography>
          IV unfractionated heparin is preferred agent in this patient cohort.
          <p>
            If enoxaparin is used, measure anti-factor Xa level (4 hours post
            dose) after the 3rd or 4th dose and then measure every second day.
          </p>
        </Typography>,
      ]}
    />,
  ];

  let reference = [
    <Typography variant="caption" display="block">
      The decision support included within this calculator is based upon TPCH Safe use of enoxaparin procedure.  
      Additional information relating to enoxaparin is available within the Product Information and Statewide 
      Guidelines for Anticoagulation and Prophylaxis using Low Molecular Weight Heparin (LMWH) in adult patients.
    </Typography>
  ];
  // DG Old reference text.
    // <Typography variant="caption" display="block">
    //   References:
    //   <ol>
    //     <li>MIMS Online. Clexane product information. Accessed 11 Sep 2006</li>
    //     <li>
    //       Green B, Duffull S. Development of a dosing strategy for enoxaparin in
    //       obese patients. Br J Clin Pharmacol. 2003;56:96-103.
    //     </li>
    //     <li>
    //       Kruse MW, Lee JJ. Retrospective evaluation of a pharmacokinetic
    //       program for adjusting enoxaparin in renal impairment. Am Heart J. 2004
    //       Oct;148:582-9.
    //     </li>
    //     <li>
    //       Safe Medication Practice Unit. Patient Safety Alert: Enoxaparin
    //       (draft). Mar 2006.
    //     </li>
    //     <li>
    //       Roberts GW. Dosing of key renally cleared drugs in the elderly - time
    //       to be wary of the eGFR. J Pharm Pract Research. 2006;36:204
    //     </li>
    //   </ol>
    // </Typography>

  return (
    <div className="results">
      <Card className={crclcontext.crclClass} data-testid="creatinine-result-card">
        {(+crclcontext.crcl <= +crclcontext.crclIdeal) && 
          <CardContent>
            <Typography variant="h5">Estimated CrCl</Typography>
            <Typography variant="caption">Using <strong><u>ACTUAL</u></strong> body weight - {crclcontext.weight} kgs </Typography>
            <Typography fontSize="14" variant="caption" gutterBottom>
              {crclcontext.crclSub}
            </Typography>
            <Typography variant="h4" className={classes.dosage}>
              {crclcontext.crcl} mL/min
            </Typography>
          </CardContent>
        }
        {(+crclcontext.crclIdeal < +crclcontext.crcl) && <CardContent>
            <Typography variant="h6">Using <strong><u>IDEAL</u></strong> body weight - {crclcontext.idealWeight} kgs </Typography>
              <Typography fontSize="14" variant="caption" gutterBottom>
                {crclcontext.crclSub}
              </Typography>
              <Typography variant="h4" className={classes.dosage}>
                {crclcontext.crclIdeal} mL/min
              </Typography>
          </CardContent>}       
        <CardActions>
          <Button
            variant="contained"
            disableElevation
            className="calcButton"
            onClick={backToCalc}
          >
            Re-calculate CrCl
          </Button>
        </CardActions>
      </Card>
      
      <Card className="crclStandard">
        <CardContent className={classes.estimatesHeading}>
          <Typography variant="body2">CrCl Estimates</Typography>
          <IconButton 
            className={clsx(classes.expand, {
              [classes.expandOpen]: estExpanded,
            })}
            onClick={handleExpandClick}
            aria-expanded={estExpanded}
            aria-label="show more">
            <ExpandMoreIcon />
          </IconButton>
        </CardContent>
        <Collapse in={estExpanded}>
          <CardContent>
          <Typography variant="h6">Using <strong><u>ACTUAL</u></strong> body weight - {crclcontext.weight} kgs </Typography>
          <Typography fontSize="14" variant="caption" gutterBottom>
            {crclcontext.crclSubActual}
          </Typography>
          <Typography variant="h4" className={classes.dosage}>
            {crclcontext.crcl} mL/min
          </Typography>
          <Typography variant="h6">Using <strong><u>IDEAL</u></strong> body weight - {crclcontext.idealWeight} kgs </Typography>
          <Typography fontSize="14" variant="caption" gutterBottom>
            {crclcontext.crclSubIdeal}
          </Typography>
          <Typography variant="h4" className={classes.dosage}>
            {crclcontext.crclIdeal} mL/min
          </Typography>
          <Typography variant="body2">
            <p>
              Consult your pharmacist for further advice on use of actual or 
              ideal body weight when estimating renal function and medication 
              dosing, particularly where estimated renal function is much lower 
              when actual body weight is used
            </p>
          </Typography>
          </CardContent>
        </Collapse>
      </Card>

      <DialogFullScreen
        data-testid="full-anticoag-dialog"
        //classprop={classes.card}
        buttonText="Full anticoagulation"
        title="Full anticoagulation"
        content={crclcontext.anticoagulationText}
        colour="primary"
      />

      <DialogFullScreen
        data-testid="prophylaxis-dialog"
        //classprop={classes.card}
        buttonText="Prophylaxis"
        title="Prophylaxis"
        content={crclcontext.prophylaxisText}
        colour="primary"
      />

      <DialogFullScreen
        buttonText="Dosing Guidelines"
        title="Dosing Guidelines"
        content={dosingGuidelines}
        colour="secondary"
      />

      <DialogFullScreen
        buttonText="Dose Adjustments"
        title="Dose Adjustments"
        content={doseAdjustments}
        colour="secondary"
      />

      <DialogFullScreen
        buttonText="Monitoring Guidelines"
        title="Monitoring Guidelines"
        content={monitoringGuidelines}
        colour="secondary"
      />

      <DialogFullScreen
        //classprop={classes.card}
        buttonText="Cockcroft-Gault Formula"
        title="Cockcroft-Gault Formula"
        content={cockcroft}
        colour="primary"
      />

      <Paper
        elevation={0}
        className={classes.references}
        children={reference}
      />
    </div>
  );
};



export default withRouter(Results);
